import React, { useEffect, useState } from "react";
import AddUser from "../pages/AddUser";
import Account from "../pages/Account";
import UserAccess from "../pages/UserAccess";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { FaTimes } from "react-icons/fa";

export default function Users() {
  // ✅ FIXED STATE
  const [userRole, setUserRole] = useState(null);
  const [tab, setTab] = useState("useraccess");


  const navigate = useNavigate();
  // console.log("userRole:", userRole);

  const menuItems = [
    { key: "adduser", label: "Add New User" },
    { key: "account", label: "Account" },
    { key: "useraccess", label: "User Access" },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("User expired, please login again");
      navigate("/");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      // console.log("decode",decoded)

      const role = decoded.role.role?.toLowerCase();

      setUserRole(role);
    } catch (err) {
      // console.error("Invalid token:", err);
      setUserRole(null);
      // navigate("/");
    }
  }, [navigate]);
  const visibleMenuItems =
    userRole === "user"
      ? menuItems.filter((item) => item.key !== "adduser")
      : menuItems;

  return (
    <div className="
  users-layout flex ml-[8.3125rem] mr-[3.6875rem] min-h-[57.9167rem] mt-[1.3125rem] bg-[#051E1C] 
  mb-[2rem] rounded-[0.625rem] overflow-hidden
">


      {/* LEFT SIDEBAR */}
      <aside className="w-[22.375rem] border-r border-white/15 bg-[#051E1C] flex flex-col">
        <div className="flex-1 pt-[3.375rem] pl-[2.3125rem] pr-[3.0625rem]">
          <nav className="space-y-4">
            {visibleMenuItems.map((item) => {
              const isActive = tab === item.key;

              return (
                <button
                  key={item.key}
                  onClick={() => setTab(item.key)}
                  className={`
    w-[17rem] h-[4rem] pl-[2.333rem] font-poppins text-[1.125rem] flex items-center px-8 py-4 text-left
    font-normal transition-all duration-200
    ${isActive
                      ? "text-white bg-[#072E2A]"
                      : "text-[#676F6E] hover:bg-white/5"
                    }
  `}
                >
                  {item.label}
                </button>

              );
            })}
          </nav>
        </div>
      </aside>

      {/* RIGHT CONTENT AREA */}
      <div className="flex-1 relative overflow-hidden h-[87vh]">
        {/* Main Content - Padding to avoid overlapping close button */}
        <div className="h-full pb-8">
          <button onClick={() => navigate("/dashboard")}
            className="absolute top-4 right-4 w-[2.5625rem] h-[2.5625rem] flex items-center justify-center rounded-full bg-white text-[#204D4C] hover:bg-gray-200 transition-colors"
          >
            <FaTimes />
          </button>

          {tab === "adduser" && <AddUser />}
          {tab === "account" && <Account />}
          {tab === "useraccess" && <UserAccess />}
        </div>
      </div>
    </div>
  );
}
